import { gigyaActions } from '../../actions/actions-const';
import CONTENT_TYPE_ID from 'globalConst/contentTypes-const';

const initialState = {
  autoPlayAfterLogin: false,
  attemptingLogin: false,
  isLoggedIn: false,
  isLoaded: false,
  isLoading: false,
  accountInfo: null,
  signature: null,
  prefersHDSources: false,
  continueListeningClipCollection: [],
};

function makeSignature(accountInfo) {
  return {
    UID: accountInfo.UID,
    signature: accountInfo.UIDSignature,
    timestamp: parseInt(accountInfo.signatureTimestamp, 10),
  };
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case gigyaActions.ATTEMPT_LOGIN:
      return {
        ...state,
        attemptingLogin: true,
        autoPlayAfterLogin: action.autoPlayAfterLogin,
      };
    case gigyaActions.ACCOUNT_INFO_LOADING:
      return { ...state, isLoading: true };
    case gigyaActions.LOGIN:
      return {
        ...state,
        attemptingLogin: false,
        isLoading: false,
        isLoaded: true,
        isLoggedIn: true,
        accountInfo: action.accountInfo,
        signature: makeSignature(action.accountInfo),
      };
    case gigyaActions.UPDATE_PROFILE:
      return {
        ...state,
        accountInfo: action.accountInfo,
        signature: makeSignature(action.accountInfo),
      };
    case gigyaActions.NOT_LOGGED_IN:
      return {
        ...state,
        attemptingLogin: false,
        isLoggedIn: false,
        isLoading: false,
        isLoaded: true,
      };
    case gigyaActions.LOGOUT:
      return {
        ...initialState,
        attemptingLogin: false,
        prefersHDSources: false,
        isLoaded: true,
      };
    case gigyaActions.PREFERS_HD_SOURCES:
      return {
        ...state,
        attemptingLogin: false,
        prefersHDSources: action.payload,
      };
    case CONTENT_TYPE_ID.CONTINUE_LISTENING_CLIP_COLLECTION:
      return {
        ...state,
        continueListeningClipCollection: action.items,
      };
    default:
      return state;
  }
}

/**
 * Given the current state, it returns the user
 *
 * @param {object} state
 * @returns {object}
 */
export const getUser = (state) => state.user;

/**
 * Given the current state, it returns whether or not the user is logged in
 *
 * @param {object} state
 * @returns {boolean} isLoggedIn
 */
export const getIsLoggedIn = (state) => state.user.isLoggedIn;

/**
 * Given the current state, it returns whether or not gigya is loading login information
 *
 * @param {object} state
 * @returns {bool}
 */
export const getIsGigyaLoading = (state) => state.user.isLoading;

/**
 * Given the current state, it returns whether or not the user is in-process of logging in
 *
 * @param {object} state
 * @returns {bool}
 */
export const getIsUserAttemptingLogin = (state) => state.user.attemptingLogin;

/**
 * Given the current state, it returns whether or not the user prefers to listen HD streams
 *
 * @param {object} state
 * @returns {bool}
 */
export const getUserPrefersHDSources = (state) => state.user.prefersHDSources;

/**
 * Given the current state, it returns the clip collection
 *
 * @param {object} state
 * @returns {object}
 */
export const getContinueListeningClipCollection = (state) => state.user.continueListeningClipCollection;
